// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8bbf56dd","324":"edd30c20","453":"4747ef40"}[chunkId] + ".chunk.js";
};